import { useReferenceSafeObject, useMutationObserver } from '@flex-design-system/fx-utils/hooks';
import { useState, useCallback, useEffect } from 'react';
import { SELECT_SEARCH_DATA_ROLE } from '../constants/dataRoles.mjs';

function useOptionObserver(element, optionsRaw = { fallbackState: -1 }) {
  const options = useReferenceSafeObject(optionsRaw);
  const { fallbackState, selector = "", ...restOptions } = options;
  const [optionCount, setOptionCount] = useState(fallbackState ?? -1);
  const updateOptionCount = useCallback(() => {
    if (element === null) {
      return;
    }
    const optionSelector = `[role="option"]:not([hidden=""])${selector}`;
    const optionElement = element.querySelectorAll(optionSelector);
    const searchEmptyElement = element.querySelector(
      `[data-role="${SELECT_SEARCH_DATA_ROLE}"]`
    );
    const optionElementsUnderSearchEmpty = searchEmptyElement?.querySelectorAll(optionSelector);
    setOptionCount(
      optionElement.length - (optionElementsUnderSearchEmpty ?? []).length
    );
  }, [element, selector]);
  useMutationObserver(element, {
    options: {
      ...restOptions,
      childList: true,
      subtree: true,
      attributeFilter: ["hidden", ...restOptions?.attributeFilter ?? []]
    },
    callback: updateOptionCount
  });
  useEffect(() => {
    updateOptionCount();
  }, [updateOptionCount]);
  return optionCount;
}

export { useOptionObserver as default };
//# sourceMappingURL=useOptionCount.mjs.map
